import { MockPath } from '@library/common/http/mock-path.mock';

import { randomArray } from '@library/common/functions';
import { MockTemplate } from './template.mock';

export const TemplatesRoutes: MockPath<unknown>[] = [
   { path: 'template/.*', verb: 'GET', type: 'template', collection: () => [ new MockTemplate() ]},
   { path: 'template', verb: 'GET', type: 'template', collection: () => randomArray( MockTemplate )},
];
